import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import useModalInformacoes, { LOAD_MESSAGE } from './ModalInformacoesHook'
import { Btn, CustomCalendar, CustomModal } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function ModalInformacoes({ show, onModalClose, onModalSave, dispatch, entrega }) {
  const { state, localDispatch } = useModalInformacoes()

  useEffect(() => {
    if (show) {
      localDispatch.onInit(entrega)
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_UPDATE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveUpdateDelivery(state.entrega)
        break
      case LOAD_MESSAGE.LOADING_EDIT:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        onModalSave()
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Entrega"
      isVisible={show}
      width={850}
      onClose={() => {
        localDispatch.resetState()
        onModalClose()
      }}
    >
      <form className="p-grid">
        <div className="p-col-6">
          <CustomCalendar
            marginTop={9}
            label="Data de Entrega:"
            value={state.entrega.deliveried_date_formatted}
            onChange={value => localDispatch.onInputChange('deliveried_date_formatted', value)}
            showTime
            hourFormat="24"
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.entrega)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalInformacoes)
